import * as React from 'react';

import classNames from 'classnames';

import {colors} from '../colors/colors';
// @ts-expect-error - imported from .js/.jsx file
import {SolidInfoIcon} from '../icon/svg/solid-info-icon';

import styles from './info-icon-wrapper.module.css';

type Props = {
    isHidden?: boolean;
    children: React.ReactNode;
};

export function InfoIconWrapper(props: Props) {
    return (
        <div
            className={classNames(styles.wrapper, {
                [styles['wrapper--hidden']]: props.isHidden,
            })}
        >
            <SolidInfoIcon size={16} color={colors.blue} className={styles.icon} />
            {props.children}
        </div>
    );
}
